module.exports = __webpack_public_path__ + "static/media/LPIC-3-legacy-Mixed.70cc6787.jpg";